import lang from '../lang/en';

class LoadingScreen {
    render() {
        document.querySelector('omnicms-calendar').insertAdjacentHTML('afterend', '<div id="omnicms-calendar-loader"></div>');
        this.el = document.getElementById('omnicms-calendar-loader');

        if (document.head.attachShadow) {
            this.shadowDOM = this.el.attachShadow({mode: 'open'});
            const wrapper = document.createElement('div');
            this.shadowDOM.append(wrapper);
            wrapper.insertAdjacentHTML('afterbegin', this.template());
        } else {
            this.el.innerHTML = lang.BrowserNotSupported;
        }
    }

    template() {
        return `
            <style>
                @keyframes loadingData {
                    from {
                        transform: rotate(0deg);
                    }

                    to {
                        transform: rotate(360deg);
                    }
                }

                .loading-container {
                    background-color: #f7f7f7;
                    font-family: Helvetica, Arial, sans-serif;
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding-top: 190px;
                    padding-bottom: 195px;
                    color: #364046;
                }

                .loading-container:focus {
                    outline: 2px solid #000000;
                }

                .loading-sub-container {
                    text-align: center;
                }

                .icon-loading {
                    animation: loadingData 4s linear infinite;
                }

                .icon-loading {
                    height: 50px;
                    width: 50px;
                    fill: #364046;
                }

                .loading-text {
                    font-size: 18px;
                    font-weight: 800;
                }
            </style>
            <div class="loading-container">
                <div class="loading-sub-container">
                    <svg role="img" class="icon-loading" version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                        <path d="M8.667 16c0 0.611-0.214 1.131-0.642 1.558s-0.947 0.642-1.558 0.642-1.131-0.214-1.558-0.642-0.642-0.947-0.642-1.558 0.214-1.131 0.642-1.558 0.947-0.642 1.558-0.642 1.131 0.214 1.558 0.642 0.642 0.947 0.642 1.558zM9.262 7.063c0.611 0 1.131 0.214 1.558 0.642s0.642 0.947 0.642 1.558-0.214 1.131-0.642 1.558-0.947 0.642-1.558 0.642-1.131-0.214-1.558-0.642-0.642-0.947-0.642-1.558 0.214-1.131 0.642-1.558 0.947-0.642 1.558-0.642zM9.262 20.538c0.611 0 1.131 0.214 1.558 0.642s0.642 0.947 0.642 1.558-0.214 1.131-0.642 1.558-0.947 0.642-1.558 0.642-1.131-0.214-1.558-0.642-0.642-0.947-0.642-1.558 0.214-1.131 0.642-1.558 0.947-0.642 1.558-0.642zM18.2 6.467c0-0.611-0.214-1.131-0.642-1.558s-0.947-0.642-1.558-0.642-1.131 0.214-1.558 0.642-0.642 0.947-0.642 1.558 0.214 1.131 0.642 1.558 0.947 0.642 1.558 0.642 1.131-0.214 1.558-0.642 0.642-0.947 0.642-1.558zM16 23.333c0.611 0 1.131 0.214 1.558 0.642s0.642 0.947 0.642 1.558-0.214 1.131-0.642 1.558-0.947 0.642-1.558 0.642-1.131-0.214-1.558-0.642-0.642-0.947-0.642-1.558 0.214-1.131 0.642-1.558 0.947-0.642 1.558-0.642zM22.738 20.538c0.611 0 1.131 0.214 1.558 0.642s0.642 0.947 0.642 1.558-0.214 1.131-0.642 1.558-0.947 0.642-1.558 0.642-1.131-0.214-1.558-0.642-0.642-0.947-0.642-1.558 0.214-1.131 0.642-1.558 0.947-0.642 1.558-0.642zM25.533 13.8c0.611 0 1.131 0.214 1.558 0.642s0.642 0.947 0.642 1.558-0.214 1.131-0.642 1.558-0.947 0.642-1.558 0.642-1.131-0.214-1.558-0.642-0.642-0.947-0.642-1.558 0.214-1.131 0.642-1.558 0.947-0.642 1.558-0.642z"></path>
                    </svg>
                    <div class="loading-text">${lang.LoadingCalendar}</div>
                </div>
            </div>
        `;
    }

    remove() {
        this.el?.remove();
    }
}

/*
    a single instance of the loading screen is exported instead of the class itself
    since the same instance needs to be shared across modules
*/
const loadingScreen = new LoadingScreen();
export { loadingScreen };